<template>
  <v-container fluid class="page-wrap">
     <v-row>
        <v-col cols="12" class="text-center">
          <header-vue />
        </v-col>
      <v-col
        cols="12"
        class="mb-5"
        lg="12"
      >
        <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
            <v-card-title class="page-title-row">
                <div>
                    <div class="text-overline accent--text font-weight-bold">WEBSITE</div>
                    <div class="text-h6 font-weight-bold primary--text">Website Builder</div>
                    <div class="text-body-2 grey--text">Set up, customize, and publish your school's public website</div>
                </div>
            </v-card-title>
            <v-card-text>
                <v-tabs v-model="tab" color="primary" class="website-tabs">
                <v-tab key="setup"><v-icon left>mdi-web-outline</v-icon>Setup</v-tab>
                <v-tab key="template"><v-icon left>mdi-palette-outline</v-icon>Template</v-tab>
                <v-tab key="pages"><v-icon left>mdi-file-document-edit-outline</v-icon>Pages</v-tab>
                <v-tab key="media"><v-icon left>mdi-folder-multiple-image</v-icon>Media</v-tab>
                <v-tab key="domain"><v-icon left>mdi-earth</v-icon>Domain</v-tab>
                <v-tab key="preview"><v-icon left>mdi-eye-outline</v-icon>Preview</v-tab>
                </v-tabs>

                <v-divider class="mb-4"/>

                <v-tabs-items v-model="tab">
                <v-tab-item key="setup"><WebsiteSetup :website="website" :authToken="authToken" :school="school" /></v-tab-item>
                <v-tab-item key="template"><ThemeSelector :website="website" :authToken="authToken" :school="school" /></v-tab-item>
                <v-tab-item key="pages"><PageEditor :website="website" :authToken="authToken" :school="school" /></v-tab-item>
                <v-tab-item key="media"><MediaManager :website="website" :authToken="authToken" :school="school" /></v-tab-item>
                <v-tab-item key="domain"><DomainSettings :website="website" :authToken="authToken" :school="school" /></v-tab-item>
                <v-tab-item key="preview"><WebsiteLivePreview v-if="website" :domain="website.subdomain_url" /></v-tab-item>
                </v-tabs-items>
            </v-card-text>
        </v-card>
      </v-col>
     </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import DomainSettings from './Settings.vue';
import ThemeSelector from './ThemeSelector.vue';
import WebsiteSetup from './WebsiteSetup.vue';
import PageEditor from './PageEditor.vue';
import MediaManager from './MediaManager.vue';
import HeaderVue from '../../components/Header.vue'
import WebsiteLivePreview from './WebsiteLivePreview.vue';

export default {
  components: { DomainSettings, PageEditor, MediaManager, ThemeSelector, WebsiteSetup, HeaderVue, WebsiteLivePreview },
    data() {
        return {
            tab: 0,
            website: null,
            loading: false,
            authToken:sessionStorage.getItem('authToken') ?? null,
            school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        };
    },
    mounted() {
        this.fetchWebsite();
    },
    methods: {
        async fetchWebsite() {
            this.loading = true;
            try {
                const { data } = await axios.get(process.env.VUE_APP_BASEURL+'/websites?school_id='+this.school.school_id,{
                headers: {'Authorization': 'Bearer '+this.authToken}
            });
                this.website = { ...data.data };
            } catch (error) {
                this.$toast.error('Failed to load website details');
            } finally {
                this.loading = false;
            }
        },
    }
};
</script>

<style scoped>
.website-tabs >>> .v-tab {
    font-weight: 600;
    text-transform: none;
    letter-spacing: normal;
    border-radius: 8px 8px 0 0;
}
</style>
